'use strict';
import {
  ReduxListFilterStreamedContainer,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, reduxList} from '../../redux/autoList';
import {UserPinListComponent} from './UserPinListComponent';


const ListComponent = ReduxListStreamedContainer(UserPinListComponent, reduxList, componentOptions);
export const AutoUserPinListComponent = ReduxListFilterStreamedContainer(ListComponent, reduxList, componentOptions);



// WEBPACK FOOTER //
// ./src/js/priorities/components/UserPinList/AutoUserPinListComponent.js